import React, { Key } from "react";
import { DateRangeFilter } from "../../../components/date-range-filter";

const NULL_SELECTION: Key[] = [];

export const filterUpdatedAt = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
}: {
  selectedKeys: Key[];
  setSelectedKeys: (selectedKeys: Key[]) => void;
  confirm: () => void;
  clearFilters?: () => void;
}) => (
  <DateRangeFilter
    defaultValue={{
      from: Number(selectedKeys[0]) > 0 ? new Date(Number(selectedKeys[0])) : null,
      to: Number(selectedKeys[1]) > 0 ? new Date(Number(selectedKeys[1])) : null,
    }}
    onApplyFilter={(value) => {
      setSelectedKeys(
        value ? [value.from?.getTime() ?? 0, value.to?.getTime() ?? 0] : NULL_SELECTION
      );
      confirm();
    }}
    onClearFilter={() => {
      clearFilters && clearFilters();
      confirm();
    }}
  />
);
